import React from 'react'
import { Box, SxProps, Theme } from '@mui/material'

type ShortcutKeyItem = string | { label: string; sx?: SxProps<Theme> }

type ShortcutTooltipTitleProps = {
    label: string
    children: React.ReactNode
}

type ShortcutKeysProps = {
    keys: ShortcutKeyItem[]
}

const plusSx = {
    px: 0.25,
    color: 'text.secondary',
    lineHeight: 1,
} as const

export function ShortcutKeys({ keys }: ShortcutKeysProps) {
    return (
        <>
            {keys.map((key, index) => {
                const label = typeof key === 'string' ? key : key.label
                const keySx = typeof key === 'string' ? undefined : key.sx

                return (
                    <React.Fragment key={index}>
                        {index > 0 && (
                            <Box component="span" sx={plusSx}>
                                +
                            </Box>
                        )}
                        <Box component="kbd" sx={keySx}>
                            {label}
                        </Box>
                    </React.Fragment>
                )
            })}
        </>
    )
}

export function ShortcutTooltipTitle({ label, children }: ShortcutTooltipTitleProps) {
    return (
        <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', fontSize: '12px' }}>
            {label}
            <Box
                component="span"
                sx={(theme) => ({
                    display: 'inline-block',
                    width: '1px',
                    height: '16px',
                    mx: 1,
                    flexShrink: 0,
                    bgcolor:
                        theme.palette.mode === 'dark'
                            ? theme.palette.text.tertiary
                            : 'rgba(255, 255, 255, 0.55)',
                })}
            />
            {children}
        </Box>
    )
}
